import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 90%;
    max-width: var(--wrapper-max-size);
    margin: 0 auto;
`